import { createContext } from 'react';
import { ChannelTypes } from 'store/types/channeTypes';
import { CheckDigitPolicy } from 'store/types/checkDigitPolicy';
import { ConfigurationState } from 'services/Configuration';
import { CustomBranding } from '@ds/ui';
import { Branding, defaultBranding } from 'store/types/branding';

export interface IVerifyApplicationContext {
    customBranding: CustomBranding | undefined;
    branding: Branding;
    isDocumentLocked: boolean;
    language: string;
    displayChannel: ChannelTypes;
    phoneNumberDigitCheck: CheckDigitPolicy;
    allowRecipientProvidedPhoneNumber: boolean;
    configurationState: ConfigurationState;
    exception: any;
    updateLanguage?: (language: string) => void;
}

const VerifyApplicationContext = createContext<IVerifyApplicationContext>({
    customBranding: undefined,
    branding: defaultBranding,
    isDocumentLocked: false,
    language: '',
    displayChannel: 'SMSandPhoneCall',
    phoneNumberDigitCheck: 'None',
    allowRecipientProvidedPhoneNumber: false,
    configurationState: 'Error',
    exception: undefined,
    updateLanguage: undefined
});

export default VerifyApplicationContext;
